module.exports = __webpack_public_path__ + "static/media/Color@2x.9ce00e1b.svg";